import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get_orders } from '../../store/reducers/orderReducer';

const Downloads = () => {
  const [state, setState] = useState('all');

  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { myOrders } = useSelector((state) => state.order);

  useEffect(() => {
    if (userInfo?.id) {
      dispatch(get_orders({ status: state, customerId: userInfo.id }));
    }
  }, [state, dispatch, userInfo]);

  return (
    <div className="bg-white p-4 rounded-md">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold text-slate-600">My Downloads</h2>
      </div>

      <div className="pt-4">
        <div className="relative overflow-x-auto rounded-md">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-gray-200">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Order Id
                </th>
                <th scope="col" className="px-6 py-3">
                  Price
                </th>
                <th scope="col" className="px-6 py-3">
                  Payment Status
                </th>
                <th scope="col" className="px-6 py-3">
                  Downloads
                </th>
              </tr>
            </thead>
            <tbody>
              {myOrders
                .filter(
                  (o) =>
                    o.payment_status === 'paid' && // Only orders with payment_status 'paid'
                    o.products.some(
                      (product) =>
                        product.downloadablePDFUrl || // Include products with a single downloadable URL
                        (product.downloadablePDFUrls &&
                          product.downloadablePDFUrls.length > 0) // Or products with an array of downloadable URLs
                    )
                )
                .map((o, i) => (
                  <tr className="bg-white border-b" key={i}>
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      #{o._id}
                    </td>
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      ${o.price}
                    </td>
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      {o.payment_status}
                    </td>
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      {o.products.map((product, j) => (
                        <div key={j} className="mb-2">
                          <div className="font-semibold">
                            Product: {product.name}
                          </div>
                          {product.downloadablePDFUrl && (
                            <a
                              href={product.downloadablePDFUrl}
                              download
                              className="text-blue-500 underline mr-2"
                            >
                              Download
                            </a>
                          )}
                          {product.downloadablePDFUrls &&
                            product.downloadablePDFUrls.map((url, k) => (
                              <div key={k}>
                                <a
                                  href={url}
                                  download
                                  className="text-blue-500 underline"
                                >
                                  Download {k + 1}
                                </a>
                              </div>
                            ))}
                        </div>
                      ))}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Downloads;
